import React from 'react';
import Container from '../../../../components/Container';
import styles from './Desktop.module.css';
import Popup from '../../../../components/Popup/Popup';
import PopupContent from '../../../../components/Popup/PopupContent';

import { oneDineLogo } from '../../../../assets/images';

export default function Desktop(props) {
    const { popup, closePopup } = props;

    return (
        <Container style={styles.container}>
            <Popup visible={!!popup} closePopup={closePopup} popupStyle={{width:'50%'}}>
                <PopupContent {...popup} />
            </Popup>
            <img className={styles.logo} alt="splash" src={oneDineLogo} />
        </Container>
    );
}
